import { ref, computed } from "vue";
import { apiClient } from "@/services/auth-header";
import { useUiStore } from "@/store/useUiStore";
import { useAuthStore } from "@/store/auth.module";
import { useAnalytics } from "@/composables/useAnalytics";

/** 협업 신청 폼 로직 (기존 문의 inquiryFunction 패턴). 첨부 없음 → JSON POST. */
export function collabApplyFunction() {
  const uiStore = useUiStore();
  const authStore = useAuthStore();
  const { trackFormSubmit } = useAnalytics();
  const isLogin = authStore.status.loggedIn;
  const apiUrl = computed(() => (isLogin ? "/v1/support" : "/v1/support/guest"));

  const collab = ref({
    name: "",
    phoneNum: "",
    email: "",
    companyName: "",
    interestArtist: "",
    content: "",
    preferredContactTime: "", // "" | MORNING | AFTERNOON | ETC
  });

  const formatPhoneNumber = () => {
    const cleaned = (collab.value.phoneNum || "").replace(/\D/g, "");
    let formatted = "";
    if (cleaned.length > 3) {
      formatted = cleaned.slice(0, 3) + "-";
      if (cleaned.length > 7) {
        formatted += cleaned.slice(3, 7) + "-" + cleaned.slice(7, 11);
      } else {
        formatted += cleaned.slice(3, 7);
      }
    } else {
      formatted = cleaned;
    }
    collab.value.phoneNum = formatted;
  };

  const loadProfile = async () => {
    if (!isLogin) return;
    try {
      uiStore.showLoading();
      const { data } = await apiClient.get("/v1/users/me");
      collab.value.name = data.name || "";
      collab.value.email = data.email || "";
      collab.value.phoneNum = data.phoneNum || "";
      formatPhoneNumber();
    } catch (error) {
      console.error("loadProfile err :", error);
    } finally {
      uiStore.hideLoading();
    }
  };

  const validate = () => {
    if (!collab.value.name || !collab.value.name.trim()) {
      alert("이름을 입력해주세요!");
      return false;
    }
    if (!collab.value.phoneNum || !/^(01[0-9]-\d{3,4}-\d{4}|\d{10,11})$/.test(collab.value.phoneNum)) {
      alert("유효한 연락처를 입력해주세요! (예: 010-1234-5678)");
      return false;
    }
    if (!collab.value.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(collab.value.email)) {
      alert("답변받을 유효한 이메일 주소를 입력해주세요!");
      return false;
    }
    return true;
  };

  const saveCollab = async (onSuccess) => {
    if (!validate()) return;
    if (!confirm("협업 신청을 등록하시겠습니까?")) return;
    try {
      uiStore.showLoading();
      await apiClient.post(apiUrl.value + "/collaborations", collab.value);
      trackFormSubmit("collaboration", "", true);
      alert("협업 신청이 접수되었습니다. 확인 후 연락드리겠습니다.");
      if (typeof onSuccess === "function") onSuccess();
    } catch (error) {
      console.error("saveCollab err :", error);
    } finally {
      uiStore.hideLoading();
    }
  };

  return { isLogin, collab, loadProfile, saveCollab, formatPhoneNumber };
}
